import type { IOfficeFileLinkHandlingInfo } from 'flora-types';
import { logUsage } from 'owa-analytics';
import { getEnhancedHostExtendedHost } from 'owa-config/lib/enhancedHost';
import type { ExtendedHost } from 'owa-config';

export async function GetOfficeFileLinkHandlingInfo(): Promise<
    IOfficeFileLinkHandlingInfo | undefined
> {
    const extendedHost: ExtendedHost | undefined = getEnhancedHostExtendedHost();

    if (extendedHost) {
        const officeFileLinkHandlingInfo: IOfficeFileLinkHandlingInfo | undefined =
            await extendedHost.FLORA;

        if (
            officeFileLinkHandlingInfo &&
            (await officeFileLinkHandlingInfo.IsUniversalSettingSupported())
        ) {
            /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
             * BASELINE: DO NOT COPY/PASTE!
             *	> Argument at index 1 for logUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
            logUsage('GetOfficeFileLinkHandlingInfo', undefined);
            return officeFileLinkHandlingInfo;
        }
    }

    return undefined;
}
